var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',{staticClass:"page-title"},[_vm._v("小语种报告")]),_c('panel',{attrs:{"url":_vm.url,"bg-url":_vm.bgUrl,"content":_vm.content,"bg-align":"left-bottom"}},[_c('div',{attrs:{"slot":"section"},slot:"section"},[_c('p',[_vm._v("我们提供地道翻译、大数据报告")]),_c('p',[_vm._v("为您精细化运营采购商")])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }